import { FormGrid } from "components/UI/Form/FormGrid";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { StatusSelectSearchable } from "components/UI/Selects/StatusSelectSearchable/StatusSelectSearchable.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FormItem } from "react-hook-form-antd";

import { OfferApiFormEditFormData } from "../formSchema";

export const ApiFormPrefillSection = () => {
    const { t } = usePaldockTranslation("forms.offer-api-form-edit");
    const { control, fieldNames } = useGeneralForm<OfferApiFormEditFormData>();

    return (
        <FormGrid cols={3}>
            <FormItem
                control={control}
                name={fieldNames.iframe_form_prefill?.name || "iframe_form_prefill"}
                label={t("fields.form_prefill.label")}
            >
                <StatusSelectSearchable />
            </FormItem>
            <FormItem
                control={control}
                name={fieldNames.iframe_affiliate_id_rewrite?.name || "iframe_affiliate_id_rewrite"}
                label={t("fields.affiliate_id_rewrite.label")}
            >
                <StatusSelectSearchable />
            </FormItem>
            <FormItem
                control={control}
                name={fieldNames.iframe_auto_submit?.name || "iframe_auto_submit"}
                label={t("fields.auto_submit.label")}
            >
                <StatusSelectSearchable />
            </FormItem>
        </FormGrid>
    );
};
